// @generated by TypeGen from LogbookModel/Track.swift - DO NOT EDIT

import type { ILogbookModel } from "./Model"

export interface ITrack extends ILogbookModel {
  id: number;
  cruiseId: number;
  tripId?: number;
  dayId?: number;
  accountId: number;
  shipId: number;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string;
  aisEntityId?: number;
  monitorStatusId?: number;
  depths?: number[];
  headings?: number[];
  lats?: number[];
  lngs?: number[];
  sogs?: number[];
  timesUtc?: number[];
  trackType: ITrackType;
  windDirections?: number[];
  windSpeeds?: number[];
}

export interface IAnchorCircle {
  statusId: number;
  lat: number;
  lng: number;
  warningRadius: number;
  alarmRadius: number;
  active: boolean;
}

export interface ITracksResponse {
  tracks: ITrack[];
  anchorCircles: IAnchorCircle[];
}

export enum ITrackType {
  track = 0,
  anchor = 1,
  ais = 2,
}
